import React from 'react';
import { t } from 'ttag';
import style from './engineBox.scss';
import { isNil } from '../../../services/helper';
import Price from '../../util/Price';

function EngineBox(props) {
    const { engine, selectedItem, onSelectItem, markedDependencies } = props;
    let isSelected = false;
    let isMarked = false;
    let containerStyle = style.container;
    let awd = '';

    if (engine.awd) {
        awd = (
            <div className={style.awd}>
                <span>{t`Allrad`}</span>
            </div>
        );
    }

    let serialParentUid = 0;
    if (isNil(selectedItem)) {
        if (engine.preselected || engine.mandatory) {
            onSelectItem(engine);
        }
    } else if (engine.uid === selectedItem.uid) {
        isSelected = true;
        serialParentUid = selectedItem.serial_parent_uid;
        containerStyle = style.container__active;
    }

    for (let i = 0; i < markedDependencies.length; i += 1) {
        if (markedDependencies[i] === engine.uid) {
            isMarked = true;
        }
    }

    if (isMarked) {
        containerStyle += ` ${style.container__marked}`;
    }

    const onChange = () => {
        if (engine.mandatory) {
            return null;
        }
        return onSelectItem(engine);
    };

    return (
        <label htmlFor={engine.uid}>
            <input className={style.radio} type="radio" value={engine.uid} id={engine.uid} checked={isSelected} onChange={() => onChange()} />
            <div className={containerStyle}>
                {awd}
                <h2>{engine.information}</h2>
                <p>
                    {engine.name}
                </p>
                <h4 className={style.numbers}>
                    {engine.weight}KG +<Price value={props.resolvePrice(engine, serialParentUid)} />
                </h4>
            </div>
        </label>
    );
}
export default EngineBox;
